<template>
  <div class="hero-with-image relative bg-primary-light overflow-hidden">
    <div class="hero-with-image__media md:absolute md:inset-0">
      <img
        v-if="content.image"
        :src="content.image.source"
        :alt="content.image.alt"
        class="block w-full h-full object-cover object-top"
      >
    </div>
    <div class="relative md:flex md:justify-end md:min-h-[clamp(400px,28vw,650px)]">
      <div class="flex flex-col justify-center text-center md:text-left px-6 py-8 md:py-12 md:px-8 lg:px-16 md:w-1/2">
        <h1 class="mb-2 text-sm font-bold text-gray-darkest" data-testid="heading-one">{{ content.headingOne }}</h1>
        <h2 class="mb-4 md:mb-6 text-26 md:text-[34px] font-bold text-primary-dark" data-testid="heading-two">{{ content.headingTwo }}</h2>
        <div
          class="richtext text-sm md:text-base mb-6 md:mb-8 md:max-w-sm text-black-medium-emphasis"
          v-dompurify-html="content.description"
          data-testid="description"
        />
        <KButton class="mx-auto md:mx-0" theme="primary" :isLoading="isLoading" @click="$emit('cta:click')">
          {{ content.getStartedButtonText }}
          <template #append>
            <KIcon
              name="arrow"
              class="h-2 ml-2 fill-current"
            />
          </template>
        </KButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { HeroWithImage } from '@/model'
import { KButton, KIcon } from '@/components'

export default defineComponent({
  name: 'HeroWithImage',
  components: { KButton, KIcon },
  emits: ['cta:click'],
  props: {
    content: {
      type: Object as () => HeroWithImage,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
})
</script>